import React from "react";
import Button from "@semcore/ui/button";
import { useMediaQuery } from "@mui/material";
import { ThemeProvider } from "@semcore/utils/lib/ThemeProvider";

const SemButton = (props) => {
  const {
    loading,
    disabled,
    size = "m",
    theme = "info",
    use = "primary",
    icon,
    name = "Button Text",
    color = "#6A3BE4",
    hMin = "33px",
    wMin = "80px",
  } = props;
  const isTab = useMediaQuery("(max-width:768px)");

  const violetPrimaryControlTheme = {
    "--intergalactic-control-primary-info": color,
    "--intergalactic-control-primary-info-hover": color,
    "--intergalactic-control-primary-info-active": color,
  };

  return (
    <ThemeProvider tokens={violetPrimaryControlTheme}>
      <Button
        {...props}
        active={false}
        disabled={disabled}
        loading={loading}
        size={isTab ? "m" : size}
        theme={theme}
        use={use}
        hMin={hMin}
        wMin={wMin}
      >
        {icon ? <Button.Addon>{icon}</Button.Addon> : null}
        <Button.Text>{name}</Button.Text>
      </Button>
    </ThemeProvider>
  );
};

export default SemButton;
